import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { EditorService } from '../../shared/services/editor.service';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import Gleap from 'gleap';
import { ThemingService } from 'src/app/shared/services/theming.service';

@Component({
    selector: 'app-index',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})

export class IndexComponent implements OnInit {
    uid: string = ""
    isCollapsed:boolean = false;
    theme: boolean = true;
    constructor(private editorServie: EditorService,private themingService:ThemingService, private router: Router,private cookieServ:CookieService) { 
        this.themingService.getThemeName().subscribe((res: any) => {
            this.theme = res;
          })
    }


    ngOnInit(): void {
        this.themingService.pingThemeName();
        this.uid = this.cookieServ.get("uid");
        if(!this.uid || !localStorage.getItem('auth_token') ){
            this.router.navigate([`login`])
        }
        // this.uid = "u-0b41030a-fa26-11ed-84d6-bb490d2813ff";
    }
    navigateToSettings() {
        this.router.navigate(['dashboard/settings']);
    }
    navigateToaudit() {
        this.router.navigate(['dashboard/audits']);
    }
    navigateTolckr() {
        this.router.navigate(['dashboard/keyword_finder']);
    }
    navigateToContentEditor() {
        this.router.navigate(['dashboard/editors']);
    }
    navigateToSumoCode() {
        this.router.navigate(['dashboard/code']);
    }
    navigateToTeam() {
        this.router.navigate(['dashboard/team']);
    }
    logOut(){
        Gleap.clearIdentity();
        localStorage.clear()
        sessionStorage.clear()
        this.cookieServ.delete("uid", "/", window.location.hostname, true, "None");
        this.cookieServ.delete("userName", "/", window.location.hostname, true, "None");
        this.cookieServ.delete("email", "/", window.location.hostname, true, "None");
        this.cookieServ.delete("plan", "/", window.location.hostname, true, "None");
        this.cookieServ.delete("first_name", "/", window.location.hostname, true, "None");
        this.cookieServ.delete("last_name", "/", window.location.hostname, true, "None");
        this.router.navigate(['login']);
    }
    collapseSideBar(){
        this.isCollapsed =! this.isCollapsed;
    }
}